import equal from "./deep-equal";
import diff, {Difference} from "./microdiff";

export class ObjectUtils {
    static deepEqual(object1: unknown, object2: unknown): boolean {
        return equal(object1, object2)
    }

    static difference(object1:  any, object2: any): Difference[] {
        return diff(object1, object2);
    }
}
